const NossosFundos = () => {
    const components = document.querySelectorAll('[data-component="nossos_fundos"]');

    components.forEach(component => {
        const cards = component.querySelectorAll('.card-item');
        const button = component.querySelector('.btn-toggle');
        const visibleCount = 4;
        let expanded = false;

        if (!cards.length || !button) return;

        // Esconde os extras logo no início
        cards.forEach((card, i) => {
            if (i >= visibleCount) {
                card.classList.add('hidden');
            }
        });

        // Clique do botão
        button.addEventListener('click', () => {
            expanded = !expanded;

            cards.forEach((card, i) => {
                if (i >= visibleCount) {
                    card.classList.toggle('hidden', !expanded);
                }
            });

            button.textContent = expanded ? "Ver menos" : "Ver mais";

            // Se recolheu (expanded = false), rola até o topo do componente
            if (!expanded) {
                component.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        });
    });
};

export default NossosFundos;

if (document.querySelectorAll('[data-component="nossos_fundos"]').length) {
    NossosFundos();
}
